export function createRandomString(length: number) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function isAlphabetic(n: string): boolean {
  const regex = /^[a-zA-Z]+$/;
  return regex.test(n);
}
